import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Login, Login_ } from './user';
import { StorageService } from '@shared/storage.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private _loginData: BehaviorSubject<Login | null> = new BehaviorSubject<Login | null>(null);

  set loginData(v: Login) {
    v.details.is_ticket = true;
    this._StorageService.setItem('nex_usr_session', v);
    this._loginData.next(v);
  }

  get loginData() {
    return this._loginData.getValue() as any;
  }

  getPartialData(key?: Partial<Login_>): Login | string {
    if (key) {
      return (this.loginData as Login)[key] as any;
    } else {
      return this.loginData as Login;
    }
  }

  constructor(
    private _StorageService: StorageService,
  ) {

    const data = this._StorageService.getItem('nex_usr_session');

    if (data) {
      this.loginData = data;
    }
    // this._loginData.subscribe((v) => {
    //   if (v) {
    //     setTimeout(() => {
    //     }, 0);
    //   }

    // })
  }

}
